import { useDispatch, useSelector } from "react-redux";
import type { StoreWithDictionaries } from "@fas/cpa-state-manager/services/selectors";
import type {
  DropDownObjItemType,
  Option,
} from "@fas/cpa-state-manager/redux/reducers";
import { getDictionaryOption } from "@fas/cpa-state-manager/services/selectors";
import { useCallback } from "react";
import { setDictionary } from "@fas/cpa-state-manager/redux/actions";

export type UseMemoryOptionsHook = {
  options: string[];
  setOptions: (arg0: string[]) => any;
};
export const useMemoryOptions: (arg0: string) => UseMemoryOptionsHook = (
  nameKey
) => {
  const dispatch = useDispatch();
  const options: string[] = useSelector(
    (state: StoreWithDictionaries): Option[] =>
      getDictionaryOption(state, nameKey)
  ).map(({ value }: Option): string => value);
  const setOptions: (arg0: string[]) => any = useCallback(
    (data: string[]) => {
      dispatch(
        setDictionary({
          [nameKey]: data.map(
            (value: string): DropDownObjItemType => ({
              label: value,
              value,
            })
          ),
        })
      );
    },
    [dispatch, nameKey]
  );
  return {
    options,
    setOptions,
  };
};
